import { Typography } from '@mui/material';
import { InitialDepositControls } from './general/InitialDepositControls';
import { FeeControls } from './general/FeeControls';
import { CheckDepositControls } from './general/CheckDepositControls';
import { CheckIssuingControls } from './general/CheckIssuingControls';
import { ACHControls } from './general/ACHControls';
import { WireControls } from './general/WireControls';
import { SavingsInterestRateControls } from './general/SavingsInterestRateControls';
import { PROGRAM_SETTINGS } from '@/constants/programSettings';

export interface SettingsSection {
  title: string;
  description: React.ReactNode;
  component: React.ComponentType;
}

export const SETTINGS_SECTIONS: SettingsSection[] = [
  {
    title: PROGRAM_SETTINGS.INITIAL_DEPOSIT_CONTROLS.LABEL,
    description:
      'The Initial Deposit Settings will apply universally to all bank account openings unless a more granular rule exists at the company level.',
    component: InitialDepositControls,
  },
  {
    title: PROGRAM_SETTINGS.FEE_CONTROLS.LABEL,
    description:
      'The following fees will apply universally to all bank accounts unless a more granular rule exists at the bank account level.',
    component: FeeControls,
  },
  {
    title: PROGRAM_SETTINGS.CHECK_DEPOSIT_CONTROLS.LABEL,
    description: '$0.00 means no limit.',
    component: CheckDepositControls,
  },
  {
    title: PROGRAM_SETTINGS.CHECK_ISSUING_CONTROLS.LABEL,
    description: '$0.00 means no limit.',
    component: CheckIssuingControls,
  },
  {
    title: PROGRAM_SETTINGS.ACH_CONTROLS.LABEL,
    description: (
      <>
        <Typography variant="body1" color="text.secondary" mt={0}>
          $0.00 means no limit.
        </Typography>
        <ul style={{ margin: 0, paddingLeft: 24, paddingBottom: 36 }}>
          <li>
            ACH Credit = SV1 originated WITHDRAWAL pushed to an external
            institution.
          </li>
          <li>
            ACH Debit = SV1 originated DEPOSIT pulled from an external
            institution.
          </li>
        </ul>
      </>
    ),
    component: ACHControls,
  },
  {
    title: PROGRAM_SETTINGS.WIRE_CONTROLS.LABEL,
    description: '$0.00 means no limit.',
    component: WireControls,
  },
  {
    title: PROGRAM_SETTINGS.SAVINGS_INTEREST_RATE_CONTROLS.LABEL,
    description:
      'The Savings Interest Rate will apply universally to all new bank account openings unless a more granular rule exists at the company level.',
    component: SavingsInterestRateControls,
  },
];
